<script setup lang="ts">
import type { DictsysArticle } from "@/types";

import LeArticleBodyCollapsed from "./LeArticleBodyCollapsed.vue";
import LeArticleBodyExpanded from "./LeArticleBodyExpanded.vue";
import LeArticleInflectionScheme from "./LeArticleInflectionScheme.vue";

const props = defineProps<{
  article: DictsysArticle;
  collapsible?: boolean;
  expanded?: boolean;
}>();
</script>

<template>
  <div class="le-article-body" :class="{ 'le-article-body--compact': props.collapsible }">
    <LeArticleInflectionScheme
      :scheme-id="props.article.id"
      :language="props.article.sourceLanguage"
      class="le-article-body__inflection-scheme"
    />

    <div class="le-article-body__content" :class="{ 'le-article-body__content--expanded': expanded }">
      <slot name="compactExpandButton" />
      <LeArticleBodyCollapsed
        v-if="collapsible && !expanded"
        class="le-article-body__collapsed-content"
        :article="props.article"
      />
      <LeArticleBodyExpanded v-else :article="props.article" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.le-article-body {
  &__inflection-scheme {
    margin-bottom: 38px;
  }

  &__content {
    word-break: break-word;
    hyphens: auto;
  }
}
</style>
